<template>
    <div class="md-custom-code federated" v-if="componentShow">
        <components is="MainComponent" />
    </div>
</template>
<script>
import {
    getFederatedComponent,
    FEDERATED_DEBUG,
    getFederatedJsUrl
} from '@/common/utils/load-remote';
// import uuidv4 from 'uuid/v4';
import util from '@/common/util';
export default {
    name: 'md-federated',
    props: {
        info: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        const info = this.info || {};
        return {
            componentShow: false,
            appid: info.appid || '',
            componentName: info.module || '',
            remoteUrl: info.url || '', // remoteUrl 在线上环境无效
            scope: info.scope || ''
        };
    },
    watch: {
        scope() {
            this.loadModule();
        },
        appid() {
            this.loadModule();
        },
        componentName() {
            this.loadModule();
        },
        remoteUrl() {
            this.loadModule();
        }
    },
    async created() {
        this.loadModule();
    },
    methods: {
        loadModule: util.debounce(async function () {
            this.componentShow = false;
            if (!this.appid || !this.componentName || !this.scope) {
                return;
            }
            console.log(this.remoteUrl, FEDERATED_DEBUG, window.location.href);
            let remoteUrl = '';
            let scope = this.scope;

            if (FEDERATED_DEBUG && this.remoteUrl) {
                // remoteUrl 在线上环境无效
                remoteUrl = this.remoteUrl;
            } else {
                remoteUrl = await getFederatedJsUrl({
                    appid: this.appid,
                    scope: scope
                });
            }

            if (!remoteUrl) {
                console.log('Remote URL is empty');
                return;
            }

            let Com = await getFederatedComponent({
                url: remoteUrl,
                scope: scope,
                module: this.componentName
            });

            this.$options.components['MainComponent'] = Com;
            this.componentShow = true;
        })
    }
};
</script>
